import { checkEnterpriseId, getResponseData } from "@helpers/_functions";

import http from "../http-common";
import BaseService from "./base.service";

class AccessProfileAccess extends BaseService {
  constructor() {
    super("access-profile");
  }
  upsert(data) {
    return http
      .post(`${this.path}/`, data)
      .then((response) => getResponseData(response));
  }

  getByEnterprise() {
    return http
      .get(`${this.path}/${checkEnterpriseId()}`)
      .then((response) => getResponseData(response));
  }

  delete(id) {
    return http
      .delete(`${this.path}/${id}`)
      .then((response) => getResponseData(response));
  }

  duplicate(id) {
    return http.post(`${this.path}/duplicate/${id}`);
  }
}

export default new AccessProfileAccess();
